// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"4086724c","464":"f32d7295","586":"1a58b2ba","648":"77e780f4","827":"13ba6c63","850":"8b1b8e65"}[chunkId] + ".chunk.css";
};